// Rendering shared by the register's two presentations.
//
// The table and the tiles show the same deals and must say the same thing about them - an
// unresolved counterparty that is marked in one and not the other is a lie in whichever one is
// wrong. So the per-value rendering lives here once rather than being written twice.

import { Link } from 'react-router';

import {
  counterpartyLabel,
  directionLabel,
  formatMoney,
  formatPrice,
  stateLabel,
} from './dealForm.js';
import { STAGE_LABELS } from './flow.js';

// The deal number is what a person knows the deal by; the link goes by the identifier, which
// never changes.
export function dealLink(deal) {
  return <Link to={`/deals/${deal.pre_deal_id}`}><code>{deal.deal_number}</code></Link>;
}

// AC6: an unresolved counterparty is visible as unresolved, not silently rendered as a real one.
export function counterparty(reference, resolved) {
  if (!reference) return '';
  if (resolved) return reference.display_name;
  return (
    <span className="unresolved" title="Not yet a counterparty record">
      {reference.display_name}
    </span>
  );
}

// The one counterparty, with what it is to Auremin on this deal: supplier on a buy, customer on a
// sell (TX-US-0039).
export function dealCounterparty(deal) {
  if (!deal.counterparty) return '';
  return (
    <>
      {counterparty(deal.counterparty, deal.counterparty_resolved)}
      {deal.direction && <span className="tag">{counterpartyLabel(deal.direction)}</span>}
    </>
  );
}

export function quantity(value) {
  return value ? `${value.amount} ${value.unit}` : '';
}

// One cell per column key in registerUrl.js COLUMNS.
export const CELLS = {
  deal_number: dealLink,
  internal_id: (deal) => deal.internal_id,
  state: (deal) => stateLabel(deal.state),
  stage: (deal) => STAGE_LABELS[deal.stage] ?? deal.stage,
  direction: (deal) => directionLabel(deal.direction),
  counterparty: dealCounterparty,
  product: (deal) => deal.product,
  trader: (deal) => deal.trader,
  volume: (deal) => quantity(deal.quantity),
  price: (deal) => formatPrice(deal.price, deal.quantity?.unit),
  value: (deal) => formatMoney(deal.value),
  last_activity: (deal) => new Date(deal.last_activity_at).toLocaleString(),
  created: (deal) => new Date(deal.created_at).toLocaleDateString(),
};
